export default __webpack_public_path__ + "static/media/favicon_dhq.c46ec4a3.ico";